import { render, staticRenderFns } from "./JournalTemplateModal.vue?vue&type=template&id=5f406206&"
import script from "./JournalTemplateModal.vue?vue&type=script&lang=js&"
export * from "./JournalTemplateModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports